import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';

// https://jira.vk.team/browse/CLOUDWEB-18603
export const uploadBigFileNewText = !IS_CORP_USER && !IS_PAID_USER && !IS_BIZ_USER && isFeature('upload-big-file-new-text');
